/**
 * Gabarit de chargement de `FlightCard`. Il en reprend la géométrie exacte,
 * y compris l'inversion mobile — barre de prix entre les segments et les
 * pastilles — pour que la liste ne saute pas quand les vraies offres arrivent.
 */
export function FlightCardSkeleton() {
  return (
    <div className="flex w-full animate-pulse flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className="flex flex-col lg:flex-row">
        <div className="contents lg:flex lg:min-w-0 lg:flex-1 lg:flex-col lg:gap-2 lg:p-4">
          {/* Header with airline */}
          <div className="flex items-center gap-2 px-3 pt-2.5 lg:p-0">
            <div className="size-7 shrink-0 rounded bg-gray-200 lg:size-9" />
            <div className="h-4 w-32 rounded bg-gray-200" />
          </div>

          <div className="flex flex-col gap-2 px-3 pt-2 lg:p-0">
            <SegmentSkeleton />
            <div className="border-t border-gray-100 pt-2">
              <SegmentSkeleton />
            </div>
          </div>

          {/* Luggage + alternatives chips */}
          <div className="order-last flex items-center gap-1.5 px-3 pb-2.5 lg:order-none lg:gap-3 lg:p-0">
            <div className="h-5 w-28 rounded bg-gray-200 lg:w-40" />
            <div className="h-5 w-24 rounded bg-gray-200 lg:w-36" />
            <div className="hidden h-8 w-44 rounded bg-gray-200 lg:block" />
            <div className="ml-auto h-5 w-20 rounded bg-gray-200 lg:w-48" />
          </div>
        </div>

        {/* Pricing */}
        <div className="flex w-full flex-col gap-2 border-y border-gray-100 bg-gray-50 px-3 py-2.5 lg:w-68 lg:shrink-0 lg:justify-between lg:border-y-0 lg:border-l lg:px-5 lg:py-4">
          <div className="flex items-center justify-between gap-3 lg:flex-col lg:items-stretch lg:gap-3">
            <div className="flex flex-col gap-1">
              <div className="h-6 w-24 rounded bg-gray-200 lg:h-8 lg:w-32" />
              <div className="h-3 w-32 rounded bg-gray-200 lg:hidden" />
            </div>
            <div className="h-10 w-28 shrink-0 rounded-md bg-gray-200 lg:w-full" />
          </div>

          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 lg:flex-col lg:items-start lg:gap-y-1.5">
            <div className="h-3 w-24 rounded bg-gray-200" />
            <div className="h-3 w-28 rounded bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  )
}

function SegmentSkeleton() {
  return (
    <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2 lg:gap-3">
      <div className="flex flex-col gap-1">
        <div className="h-4 w-12 rounded bg-gray-200" />
        <div className="h-3 w-10 rounded bg-gray-200 xl:w-24" />
      </div>
      <div className="flex flex-col items-center gap-1">
        <div className="h-2.5 w-10 rounded bg-gray-200" />
        <div className="flex w-full items-center">
          <div className="h-px flex-1 bg-gray-200" />
          <div className="mx-1.5 h-5 w-14 rounded-full bg-gray-200 lg:mx-3" />
          <div className="h-px flex-1 bg-gray-200" />
        </div>
      </div>
      <div className="flex flex-col items-end gap-1">
        <div className="h-4 w-12 rounded bg-gray-200" />
        <div className="h-3 w-10 rounded bg-gray-200 xl:w-24" />
      </div>
    </div>
  )
}
